import React from "react";
import s from "./style.module.scss";
import AvatarPlaceholder from "entities/Account/AccountInfo/icons/AvatarPlaceholder";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import ImageLazy from "shared/ui/ImageLazy";
import Coins from "shared/ui/Bonuses/icons/Coins";
import { itemsList } from "./consts";
import Item from "./Item";
import { Link } from "react-router-dom";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { Status } from "shared/ui/Status";

const UserInfo: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  return (
    <section className={s.info}>
      <div className={s.top}>
        <Link to={ROUTES_PATH.ACCOUNT} />
        <div className={s.avatar}>
          {user_info?.avatar ? (
            <ImageLazy src={user_info.avatar} alt="Avatar" />
          ) : (
            <AvatarPlaceholder />
          )}
        </div>

        <div className={s.data}>
          <p className={s.greeting}>
            Привет, {user_info?.fullname ? user_info?.fullname : "Гость"}
          </p>

          <div className={s.bonuses}>
            <span>Ваши бонусы</span>

            <div>
              <Coins />

              {user_info?.balance !== undefined ? user_info?.balance : "..."}
            </div>
          </div>

          <div className={s.status}>
            <span>Ваш статус</span>

            <Status
              color={user_info?.user_status.color}
              type={user_info?.user_status.title}
            />
          </div>
        </div>
      </div>

      <ul className={s.list}>
        {itemsList.map((item, key) => (
          <Item {...item} key={key} />
        ))}
      </ul>
    </section>
  );
};

export default UserInfo;
